
import { Injectable } from '@angular/core';
import { MobileStatusBarMode } from '../hybrid/models/status-bar-text-color';
import { NativeService } from '../hybrid/native.service';
import { StatusBarModeDirective } from '@core-directives/status-bar-mode/status-bar-mode.directive';

@Injectable({ providedIn: 'root' })
export class StatusBarService {

    activeDirectives = new Map<StatusBarModeDirective, MobileStatusBarMode>();
    directives: StatusBarModeDirective[] = [];

    constructor(private readonly hybridService: NativeService) { }

    public set(directive: StatusBarModeDirective, mode: MobileStatusBarMode | null): void {
        const isDirectiveActive = this.activeDirectives.has(directive);

        this.activeDirectives.set(directive, mode);

        if (!isDirectiveActive) {
            this.directives.push(directive);
        }

        const currentDirective = this.directives[this.directives.length - 1] || null;
        const currentMode = currentDirective ? this.activeDirectives.get(currentDirective) : MobileStatusBarMode.Dark;

        this.hybridService.overrideStatusBarMode(currentMode);
    }

    public pop(directive: StatusBarModeDirective): void {
        const isDirectiveExists = this.activeDirectives.has(directive);

        if (!isDirectiveExists) {
            return;
        }

        this.activeDirectives.delete(directive);
        this.directives = this.directives.filter(d => d !== directive);

        const currentDirective = this.directives[this.directives.length - 1] || null;
        const currentMode = currentDirective ? this.activeDirectives.get(currentDirective) : MobileStatusBarMode.Dark;

        this.hybridService.overrideStatusBarMode(currentMode);
    }
}